import styled from "@emotion/styled";
import { FIGMA_COLORS, TYPOGRAPHY } from "../../components-redesign/styles";

const TableStyles = styled.div`
  :root {
    --transition-time: 0.3s;
    --transition-timing-fn: ease-out;
    --opened-border: 2px solid #888;
    /* --closed-border: 1px solid rgba(224, 224, 224, 1); */

    --bg-transition-time: 0.3s;
  }

  .datagrid-inner-toggle {
    margin-left: 2px;
    transition: all var(--transition-time) var(--transition-timing-fn);

    &.opened {
      transform: rotate(90deg);
    }
  }

  .table-row {
    transition-property: background-color;
    transition-duration: var(--bg-transition-time);
    transition-timing-function: ease-out;
    /* border: var(--closed-border); */

    &.opened {
      background-color: rgba(202, 215, 255, var(--colorizeInner));
      border: var(--opened-border) !important;
      border-bottom: none;
    }
  }

  .inner-table-row {
    transition-property: display, opacity, transform;
    transition-duration: var(--transition-time);
    transition-timing-function: var(--transition-timing-fn);

    transition-behavior: allow-discrete;
    display: block;
    opacity: 1;
    transform: translateX(0px);

    border: var(--opened-border);
    border-top: none;

    & > td {
      padding: 0;
    }

    tr {
      background-color: rgba(247, 249, 255, var(--colorizeInner));
    }
  }

  thead {
    z-index: 100;
  }

  thead th {
    vertical-align: middle;
    color: ${FIGMA_COLORS.onSurfaceLight};
    padding: 16px;
    border-right: 1px solid ${FIGMA_COLORS.surfaceContainerMonochromeLT};
    border-bottom: 1px solid ${FIGMA_COLORS.surfaceContainerMonochromeLT};
    ${TYPOGRAPHY.labelMedium}

    &:last-of-type {
      border-right: none;
    }
    &:first-of-type {
      border-left: none;
    }
  }

  .sticky-column {
    position: sticky;
    background-color: white !important;
    z-index: 10;
    will-change: transform;
    transform: translateZ(0);
    backface-visibility: hidden;

    &.stuck::after {
      content: "";
      position: absolute;
      top: 0;
      right: -48px;
      bottom: 0;
      width: 48px;
      background: linear-gradient(
        90deg,
        rgba(75, 75, 75, 0.09) 4.33%,
        rgba(115, 115, 115, 0) 95.15%
      );
      pointer-events: none;
      z-index: 1;
    }
  }

  .sticky-column-header {
    position: sticky;
    background-color: white;
    z-index: 110;
    will-change: transform;
    transform: translateZ(0);
    backface-visibility: hidden;

    &.stuck::after {
      content: "";
      position: absolute;
      top: 0;
      right: -48px;
      bottom: 0;
      width: 48px;
      background: linear-gradient(
        90deg,
        rgba(75, 75, 75, 0.09) 4.33%,
        rgba(115, 115, 115, 0) 95.15%
      );
      pointer-events: none;
      z-index: 1;
    }
  }

  tbody tr td {
    background-color: white;
  }

  .inner-table-row tr td {
    background-color: rgba(247, 249, 255, var(--colorizeInner, 0));
  }

  .table-row.opened td {
    background-color: rgba(202, 215, 255, var(--colorizeInner, 0));
  }

  .table-row.opened .sticky-column {
    background-color: rgba(202, 215, 255, var(--colorizeInner, 0));
  }

  .inner-table-row .sticky-column {
    background-color: rgba(247, 249, 255, var(--colorizeInner, 0));
  }

  @starting-style {
    .table-row.opened {
      background-color: white;
    }

    .inner-table-row {
      display: none;
      opacity: 0;
      transform: translateX(-40px);
    }
  }
`;
export default TableStyles;
